export default __webpack_public_path__ + "static/media/logo.95e9707b.png";